module.exports = __webpack_public_path__ + "static/media/dk4018.94681fcb.png";